import {
  ChecklistItemStatusType,
  FormElement,
  FormElementType,
} from "@kolibrisoftware/customerportal-api";
import { useTheme } from "injectors/theme";
import { ListOfItemsUseCases } from "modules/list-of-items/enums/list-of-items-use-cases";
import useElementData from "modules/list-of-items/hooks/useElementData";
import { FC } from "react";
import useElementTranslations from "hooks/useElementTranslations";
import { useSelector } from "store/helpers";
import { FormSectionHeader } from "../../form-section-header/form-section-header";
import AddQuestion from "../../list-of-items-question-wrapper/add-question";
import { CustomQuestionWrapper } from "../../list-of-items-question-wrapper/custom-question/custom-question-wrapper";
import { ListOfItemsQuestionWrapper } from "../../list-of-items-question-wrapper/list-of-items-question-wrapper";
import { useStyles } from "./styles";

type Props = { sectionStructure: FormElement };

const RegularSectionComponent: FC<Props> = ({ sectionStructure }) => {
  const theme = useTheme();
  const styles = useStyles({ theme });
  const sectionData = useElementData(sectionStructure.id);
  const sectionTranslations = useElementTranslations(sectionData);
  const { formEditableStatus } = useSelector(state => state.listOfItems);

  return (
    <div className={styles.regularSectionContainer}>
      <FormSectionHeader
        sectionTranslations={sectionTranslations}
        useCase={ListOfItemsUseCases.Regular}
      />

      {sectionStructure?.elements?.map(element => {
        if (element.type !== FormElementType.Question) {
          return null;
        }
        return (
          <ListOfItemsQuestionWrapper
            questionStructure={element}
            key={`${sectionStructure.id} -- ${element.id}`}
          />
        );
      })}

      {sectionStructure?.customQuestions?.map(question => (
        <CustomQuestionWrapper
          questionStructure={question}
          key={question.id}
          useCase={ListOfItemsUseCases.Regular}
        />
      ))}
      {formEditableStatus === ChecklistItemStatusType.Open &&
        sectionData?.id &&
        sectionData.childrenCustomQuestionAllowed && (
          <AddQuestion
            sectionId={sectionData.id}
            useCase={ListOfItemsUseCases.Regular}
          />
        )}
    </div>
  );
};

export { RegularSectionComponent };
